<div class="spreadsheet-page-container">
	<div
		class="spreadsheet-container"
		(mouseup)="impactMapMouseUp()"
		(mousedown)="impactMapMouseDown($event)"
		(mousemove)="confirmMouseMove()"
		#spreadsheetContainer
		*ngIf="spreadsheetData && !isLoadingSpreadsheet && !isLoadingLabels">
		<div class="line" *ngFor="let line of spreadsheetData.lines; let indexLinha = index">
			<div
				class="item"
				[ngClass]="{
					odd: indexColuna % 2 === 1,
					header: indexLinha === 0,
					selected: indexColuna === spreadsheetData.selectedItemAxis[0] && indexLinha === spreadsheetData.selectedItemAxis[1],
				}"
				*ngFor="let cell of line.cells; let indexColuna = index"
				(click)="indexLinha !== 0 ? handleSelectedSpreadsheetItem(indexColuna, indexLinha) : null">
				<input
					[ngClass]="{ 'cursor-right': cell.header_cell && cell.header_cell.search_value === '' }"
					type="text"
					[placeholder]="cell.item_name"
					(click)="handleSelectedSpreadsheetItem(-1, -1)"
					(input)="cell.header_cell.search_value = $event.target.value; filterSpreadsheetColumn()"
					*ngIf="indexLinha === 0 && cell.item_name" />
				<span
					class="order-by"
					[ngClass]="{
						selected: spreadsheetData.sort.sort_column === indexColuna,
						'rotate-180': !spreadsheetData.sort.sort_down && spreadsheetData.sort.sort_column === indexColuna,
					}"
					*ngIf="indexLinha === 0 && cell.item_name"
					(click)="sortSpreadsheet(indexColuna)">
					<fa-icon [icon]="faSortDown"></fa-icon>
				</span>
				<span *ngIf="indexLinha !== 0 || (indexLinha === 0 && cell.item_name === '')">{{ cell.item_name }}</span>
			</div>
		</div>
	</div>

	<div
		class="spreadsheet-plastic-wrap"
		(mouseup)="impactMapMouseUp()"
		(mouseout)="impactMapMouseUp()"
		(mousemove)="impactMapMouseMove($event)"
		*ngIf="spreadsheetPos.mouseDown === true && spreadsheetPos.mouseMove === true"></div>
</div>

<div class="loading-container" *ngIf="isLoadingSpreadsheet || isLoadingLabels || (!isLoadingSpreadsheet && !spreadsheetData)">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
